import { render, staticRenderFns } from "./ShareStorageCeph.vue?vue&type=template&id=7a6abfdc"
import script from "./ShareStorageCeph.vue?vue&type=script&lang=js"
export * from "./ShareStorageCeph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports